import { atom, useRecoilState } from 'recoil';

interface ConfirmationModalState {
    isOpen: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
}

const confirmationModalState = atom<ConfirmationModalState>({
    key: 'confirmationModalState',
    default: {
        isOpen: false,
        title: '',
        message: '',
        onConfirm: () => { },
    },
});

export const useConfirmationModal = () => {
    const [modalState, setModalState] = useRecoilState(confirmationModalState);

    const showConfirmationModal = ({
        title,
        message,
        onConfirm,
    }: Omit<ConfirmationModalState, 'isOpen'>) => {
        setModalState({
            isOpen: true,
            title,
            message,
            onConfirm,
        });
    };

    const hideConfirmationModal = () => {
        setModalState((prev) => ({
            ...prev,
            isOpen: false,
        }));
    };

    return {
        modalState,
        showConfirmationModal,
        hideConfirmationModal,
    };
};